import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export default function SupportContactSuccess() {
  const ticketRef = React.useMemo(() => {
    const timestamp = Date.now().toString(36);
    const hash = Math.random().toString(36).substring(2, 6);
    return `${timestamp}-${hash}`.toUpperCase();
  }, []);

  return (
    <>
      <Helmet>
        <title>Message Sent - Attain Domains Support</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <div className="min-h-screen bg-background py-12 flex items-center justify-center">
        <div className="max-w-2xl mx-auto px-6">
          <Card className="p-12 text-center">
            <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-green-500" />
            </div>

            <h1 className="text-3xl font-bold mb-4">Message Sent Successfully!</h1>

            <p className="text-lg text-muted-foreground mb-2">
              Thank you for contacting Attain Domains support.
            </p>

            <p className="text-muted-foreground mb-8">
              We've received your message and will respond within 1 business day.
            </p>

            <div className="bg-muted/50 rounded-lg p-6 mb-8">
              <p className="text-sm text-muted-foreground mb-2">Reference Number</p>
              <p className="text-xl font-mono font-semibold">{ticketRef}</p>
              <p className="text-xs text-muted-foreground mt-2">
                Save this reference for tracking your inquiry
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/support">
                <Button variant="outline" size="lg">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Back to Support
                </Button>
              </Link>
              <Link to="/">
                <Button size="lg">
                  <Home className="w-4 h-4 mr-2" />
                  Return Home
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
